<template>
  <div class="row adminPage">
    <div class="col-md-12">
      <List
        :__list="dataArray"
        :__isOnLoad="isListOnload"
        :__editMode="false"
        :__idxOnEdition="-1"
        ></List>
    </div>

    <transition name="adminEditorOverlay">
      <div
        v-if="onEditionId !== null"
        class="adminEditorBackdrop"
        @click="cancelAction"
      ></div>
    </transition>

    <transition name="adminEditorDrawer">
      <div
        v-if="onEditionId !== null"
        class="adminEditorDrawer"
        @click.stop
      >
        <div class="adminEditorHead">
          <div class="adminEditorTitle">
            {{ onEditionIdx === -1 ? 'Nouveau compte' : 'Modifier compte' }}
          </div>
          <button type="button" class="adminEditorClose" @click="cancelAction">×</button>
        </div>

        <Edit
          :__item="onEditionItem"
          :__isOnLoad="isEditOnload"
          :email-verification-requested="emailVerification.requested"
          :email-verification-verified="emailVerification.verified"
          :email-verification-code="emailVerification.code"
          :email-verification-remaining="emailVerification.remaining"
          :email-verification-busy="emailVerification.sending || emailVerification.confirming"
          @request-email-verification="requestEmailVerification"
          @confirm-email-verification="confirmEmailVerification()"
          @update-email-verification-code="emailVerification.code = $event"
        ></Edit>
      </div>
    </transition>
  </div>
</template>
<script>
import Edit from './Edit';
import List from './List';
export default {
  components: {
    Edit,
    List,
  },
  props: {
   
  },

  data() {
    return {
      moduleRoute: '/admins',
      onEditionId: null,
      onEditionIdx: -1,
      onEditionItem: null,
      isListOnload: false,
      isEditOnload: false,
      dataArray: [],
      onGoingReq:[],
      emailVerification: {
        code: '',
        email: '',
        requested: false,
        verified: false,
        remaining: 0,
        sending: false,
        confirming: false,
        timer: null,
      },
    };
  },

  methods: {
    createEmptyItem() {
      return {
        isActive: false,
        login: '',
        pwd: '',
        type: '',
        name: '',
        email: '',
        tel: '',
        pic: '',
        cnss: '',
        post: '',
        pid: '',
      };
    },

    cancelAction() {
      this.onEditionId = null;
      this.onEditionIdx = -1;
      this.onEditionItem = null;
      this.resetEmailVerification();
    },

    showToast(message, variant = 'success') {
      this.$bvToast.toast(message, {
        title: variant === 'success' ? 'Compte utilisateur' : 'Ajout compte',
        variant,
        solid: true,
        autoHideDelay: 4000,
      });
    },

    getValidationError(item) {
      if (!item || !String(item.type || '').trim()) {
        return "Le type d'utilisateur est obligatoire.";
      }

      if (!String(item.name || '').trim()) {
        return 'Le nom et prenom sont obligatoires.';
      }

      if (!String(item.login || '').trim()) {
        return 'Le login est obligatoire.';
      }

      if (!String(item.pwd || '').trim()) {
        return 'Le mot de passe est obligatoire.';
      }

      if (String(item.pwd).length < 8 || !/[A-Za-z]/.test(String(item.pwd)) || !/\d/.test(String(item.pwd))) {
        return 'Le mot de passe doit contenir au moins 8 caracteres, une lettre et un chiffre.';
      }

      if (!item.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(item.email).trim())) {
        return "Une adresse email valide est obligatoire.";
      }

      return null;
    },

   
    saveAction() {
      if (this.onEditionId === '__draft__') {
        this.createAction();
        return;
      }

      this.onGoingReq.push({});
      let $onNext = (response) => {
        this.loadData(this.onEditionId, null, this.onEditionIdx);
      };
      
      const $onError = (error) => {
        this.showToast(error.response && error.response.data && error.response.data.message ? error.response.data.message : "Le compte n'a pas pu etre mis a jour.", 'danger');
      };
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };
      let diff = this.__.differ(
        this.dataArray[this.onEditionIdx],
        this.onEditionItem
      );
      diff.push('_id');
      let data = this._.pick(this.onEditionItem, diff);
      
      this.updateAction({ $onNext, $onError, $onComplete, data });
    },

    toggleActivateAction(id, val) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx);
      this.onGoingReq.push({});
      let $onNext = (response) => {
        this.dataArray[idx].isActive = val;
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      let data = this._.pick(this.dataArray[idx], ['_id', 'isActive']);
      data.isActive = val;
      this.updateAction({ $onNext, $onError, $onComplete, data });
    },

    deleteAction(id) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx);
      this.onGoingReq.push({});
      let $onNext = (response) => {
        if (response.data == 'OK') {
          this.dataArray.splice(idx, 1);
        }
      };

      const $onError = (error) => {
        this.showToast(error.response && error.response.data && error.response.data.message ? error.response.data.message : "Le compte n'a pas pu etre supprime.", 'danger');
      };
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      let data = this._.pick(this.dataArray[idx], ['_id']);
      this.__.httpAction({
        methode: 'DELETE',
        route: this.moduleRoute+"/"+data._id,
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    editAction(id) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx)
      this.onEditionId = id;
      this.onEditionIdx = idx;
      this.onEditionItem = this._.omit(this.dataArray[idx]);
    },

    updateAction(conf) {
      this.__.httpAction({
        methode: 'POST',
        route: this.moduleRoute,
        data: conf.data,
        onNext: conf.$onNext,
        onError: conf.$onError,
        onComplete: conf.$onComplete,
      });
    },

    createAction() {
      const validationError = this.getValidationError(this.onEditionItem);

      if (validationError) {
        this.showToast(validationError, 'danger');
        return;
      }

      if (!this.onEditionItem.emailVerificationId || !this.emailVerification.verified) {
        if (!this.emailVerification.requested) {
          this.requestEmailVerification();
          return;
        }

        if (!/^\d{6}$/.test(this.emailVerification.code)) {
          this.showToast('Saisissez le code de verification a 6 chiffres envoye par email.', 'danger');
          return;
        }

        this.confirmEmailVerification(true);
        return;
      }

      this.onGoingReq.push({});
      const $onNext = (response) => {
        this.loadData(response.data, () => {
          this.cancelAction();
          this.showToast('Le compte utilisateur a ete ajoute avec succes.');
        });
      };

      const $onError = () => {
        this.showToast("Le compte utilisateur n'a pas pu etre ajoute. Veuillez reessayer.", 'danger');
      };
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      const data = this._.omit({ ...this.onEditionItem }, ['_id']);
      this.__.httpAction({
        methode: 'PUT',
        route: this.moduleRoute,
        data,
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    requestEmailVerification() {
      const email = String(this.onEditionItem.email || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        this.showToast('Saisissez une adresse email valide avant de demander le code.', 'danger');
        return;
      }

      this.emailVerification.sending = true;
      this.__.httpAction({
        methode: 'POST',
        route: '/email-verifications/request',
        data: { email },
        onNext: () => {
          this.emailVerification.code = '';
          this.emailVerification.email = email;
          this.emailVerification.requested = true;
          this.emailVerification.verified = false;
          this.onEditionItem.emailVerificationId = '';
          this.startEmailVerificationTimer();
          this.showToast('Le code de verification a ete envoye. Il est valable pendant 10 minutes.');
        },
        onError: (error) => {
          this.showToast(error.response && error.response.data && error.response.data.message ? error.response.data.message : "Le code n'a pas pu etre envoye.", 'danger');
        },
        onComplete: () => {
          this.emailVerification.sending = false;
        },
      });
    },

    confirmEmailVerification(createAfterConfirmation = false) {
      if (!/^\d{6}$/.test(this.emailVerification.code)) {
        this.showToast('Le code de verification doit contenir 6 chiffres.', 'danger');
        return;
      }

      this.emailVerification.confirming = true;
      this.__.httpAction({
        methode: 'POST',
        route: '/email-verifications/confirm',
        data: { email: this.onEditionItem.email, code: this.emailVerification.code },
        onNext: (response) => {
          this.onEditionItem.emailVerificationId = response.data.verificationId;
          this.emailVerification.verified = true;
          this.emailVerification.requested = false;
          this.emailVerification.remaining = 0;
          this.stopEmailVerificationTimer();
          this.showToast('Adresse email confirmee.');
          if (createAfterConfirmation) this.createAction();
        },
        onError: (error) => {
          this.showToast(error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Code de verification incorrect.', 'danger');
        },
        onComplete: () => {
          this.emailVerification.confirming = false;
        },
      });
    },

    startEmailVerificationTimer() {
      this.stopEmailVerificationTimer();
      const expiresAt = Date.now() + (10 * 60 * 1000);
      const updateRemaining = () => {
        this.emailVerification.remaining = Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000));
        if (this.emailVerification.remaining === 0) {
          this.emailVerification.requested = false;
          this.emailVerification.code = '';
          this.stopEmailVerificationTimer();
        }
      };
      updateRemaining();
      this.emailVerification.timer = window.setInterval(updateRemaining, 1000);
    },

    stopEmailVerificationTimer() {
      if (this.emailVerification.timer) {
        window.clearInterval(this.emailVerification.timer);
        this.emailVerification.timer = null;
      }
    },

    resetEmailVerification() {
      this.stopEmailVerificationTimer();
      this.emailVerification.code = '';
      this.emailVerification.email = '';
      this.emailVerification.requested = false;
      this.emailVerification.verified = false;
      this.emailVerification.remaining = 0;
      this.emailVerification.sending = false;
      this.emailVerification.confirming = false;
    },

    addAction() {
      this.resetEmailVerification();
      this.onEditionId = '__draft__';
      this.onEditionIdx = -1;
      this.onEditionItem = this.createEmptyItem();
    },

    loadData(id = null, cb = null, putAt = null) {
      let $onNext = (response) => {
        if (id != null) {
          if (putAt != null) {
            if(putAt === -1) {
              const idx = (element) => element._id === id;
              var position = this.dataArray.findIndex(idx)
              console.log(position );
              this.dataArray[position] = response.data[0];
            } else {
              this.dataArray[putAt] = response.data[0];
            }
            
          } else {
            this.dataArray.unshift(response.data[0]);
          }

          if (cb) cb();
        } else {
          this.dataArray = response.data;
        }
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      this.onGoingReq.push({});
      this.__.httpAction({
        methode: 'GET',
        route: this.moduleRoute+ (id != null ? '/'+id : '/'),
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },
    
  },
  mounted() {
    //this.patch();
    this.loadData();
  },

  watch: {
    onGoingReq: function () {
      this.isListOnload = this.isEditOnload = this.onGoingReq.length > 0;
    },
    'onEditionItem.email': function (email) {
      if (this.emailVerification.email && String(email || '').trim().toLowerCase() !== this.emailVerification.email.toLowerCase()) {
        this.resetEmailVerification();
        if (this.onEditionItem) this.onEditionItem.emailVerificationId = '';
      }
    },
  },
  beforeDestroy() {
    this.stopEmailVerificationTimer();
  },
};
</script>
<style scoped>
.adminPage {
  position: relative;
}

.adminEditorBackdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.2);
  z-index: 336;
}

.adminEditorDrawer {
  position: fixed;
  top: 175px;
  left: 50%;
  width: min(760px, calc(100vw - 48px));
  max-height: calc(100vh - 195px);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 18px;
  border-radius: 20px;
  background: #eef1f5;
  box-shadow: 0 24px 55px rgba(15, 23, 42, 0.22);
  border: 1px solid rgba(226, 232, 240, 0.95);
  z-index: 337;
  transform: translateX(-50%);
}

.adminEditorHead {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}

.adminEditorTitle {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
}

.adminEditorClose {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 999px;
  background: #ffffff;
  color: #334155;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12);
}

.adminEditorDrawer-enter-active,
.adminEditorDrawer-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.adminEditorDrawer-enter,
.adminEditorDrawer-leave-to {
  transform: translate(-50%, 24px) scale(0.985);
  opacity: 0;
}

.adminEditorOverlay-enter-active,
.adminEditorOverlay-leave-active {
  transition: opacity 0.22s ease;
}

.adminEditorOverlay-enter,
.adminEditorOverlay-leave-to {
  opacity: 0;
}

@media (max-width: 768px) {
  .adminEditorDrawer {
    top: 110px;
    width: calc(100vw - 20px);
    max-height: calc(100vh - 125px);
    padding: 14px;
    border-radius: 16px;
  }
}
</style>
<style></style>
